import { HttpErrorResponse } from '@angular/common/http';
import { NotificationHandlerService } from 'projects/common/src/app/services/notification-handler.service';
import { CommunicationService } from 'src/app/services/communication';
import { Parameter } from './parameter'; // Importante: Luego revisar esta importación que genera eerror por Dependency Cycle via

/**
 * Clase base para el manejo de parámetro que obtiene sus valores de manera remota.
 * Provee metodos para la obtención del parámetro y la modificación de éste.
 */
export class ParameterAsync<T> extends Parameter<T> {
  protected urlEndpoint: string;
  private isRequestInProgress = false; // Evita múltiples solicitudes simultáneas

  /**
   * @param httpService implementación de servicio para realizar una petición HTTP GET
   * @param notificationService Servicio para manejar notificaciones
   */
  constructor(protected httpService: CommunicationService, protected notificationService: NotificationHandlerService) {
    super();
  }

  /**
   * Obtiene un valor para modificar el parámetro de la instancia actual, utilizando
   * el parámetro urlEndpoint como endpoint para el llamado http y la obtención del valor.
   *
   * Evita hacer una nueva petición si el `machineTypeId` no ha cambiado.
   */
  public start(machineTypeId?: number): Promise<T> {
    return new Promise((resolve) => {
      // if request in progress wait till it finishes
      if (this.isRequestInProgress) {
        console.log(
          `🔄 Solicitud en progreso, evitando nueva ejecución para el pinche machineTypeId=${machineTypeId} acumulado. TODO; buscar porque se acumula esta cosa`,
        );
        resolve(null);
        return;
      }

      // update last requested id and set request in progress
      this.isRequestInProgress = true;

      const argument = this.getArgument();
      if (machineTypeId) {
        argument.machineTypeId = machineTypeId;
      }

      this.httpService.get(this.urlEndpoint || this.name, argument).subscribe(
        (response: any) => {
          this.set(response as T);
          this.isRequestInProgress = false; // mark as completed
          resolve(response as T);
        },
        (error: HttpErrorResponse) => {
          this.error(`Error en solicitud.`, error.name, error.message, error.status);
          this.notificationService.error(`[${this.name}] Error en solicitud.`);
          this.set(null);
          this.isRequestInProgress = false; // mark as completd
          resolve(null);
        },
      );
    });
  }

  protected getArgument(): { [key: string]: any } {
    return {};
  }
}
